import {
  clearTimeouts,
  engine as anime,
} from "../../../../../animations/index";
import { getTemplateDurationOveride } from "../../../../shared/utils/timeline";

const timeouts = [];

const main = (props) => {
  const timeouts = [];
  const { id, format, data, templateName } = props;

  const goalData = data?.data?.dynamic?.goalData;

  const timeline = anime.timeline({
    autoplay: false,
  });

  const templateDuration = 10;
  // getTemplateDurationOveride({
  //   apiSetup: props?.apiSetup,
  //   tournamentId: props?.data?.event?.competitionId,
  //   fallback:
  //     _.find(props?.data?.data?.options, { id: "videoduration" })?.value || 0,
  //   templateName,
  //   event: data?.event
  // });

  $(`#${id} .ant-progress-bg`).css("width", "100%");
  $(`#${id} .ant-progress-bg`).css(
    "transition-duration",
    `${templateDuration}s`,
  );
  console.log('id: ', id)
  const video = $(`#${id} video.video-pitch`).get(0);
  if (video) {
    video.currentTime = 0;
    video.play();
  }

  anime({
    targets: [`#${id} .left-block-side`],
    rotateY: ["-50deg", 0],
    easing: "easeInOutQuad",
    duration: 1000,
    delay: 100
  })

  anime({
    targets: [`#${id} .left-block-shadow`],
    width: ["92px", "1px"],
    easing: "easeInOutQuad",
    duration: 1000,
    delay: 100
  })

  const timeout1 = setTimeout(() => {
    const goal = goalData?.[goalData?.length - 1];
    const isGoalPenalty = goalData?.isPenalty !== undefined ? goalData?.isPenalty : goal?.isPenalty ? goal?.isPenalty : data?.data?.updater?.isPenalty !== undefined ? data?.data?.updater?.isPenalty : false;
    let newGoalData = [...goalData];
    if (isGoalPenalty) {
      newGoalData = [goalData[goalData.length - 1]]
    }
    for (const i in newGoalData) {
      const data = newGoalData[i];
      const targetPlayer = `#player-${data?.eventId}-${data?.typeId}`;
      const targetPath = `#path-${data?.eventId}-${data?.typeId}`;

      timeline.add(
        {
          targets: targetPlayer,
          opacity: 1,
          easing: "easeOutElastic",
          scale: [1.5, 1],
          duration: 400,
        },
        i === 0 ? undefined : "-=300",
      );

      timeline.add({
        targets: targetPath,
        opacity: 1,
        strokeDashoffset: [anime.setDashoffset, 0],
        easing: "easeInOutSine",
        duration: 600,
      });
    }

    timeline.add(
      {
        targets: "#goal",
        scale: [0.5, 1],
        opacity: 1,
        easing: "easeInOutElastic",
        duration: 600,
      },
      "-=600",
    );

    timeline.play();
  }, 1000);

  return {
    timeline,
    timeouts,
  };
};

//clean up function, unmounting
export const animationCleanUp = (animationReturn) => {
  const { timeouts } = animationReturn;
  clearTimeouts(timeouts);
};

export default main;
